import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["form"]

  connect() {
    console.log("Connected")
    this.fixCSRF()
  }

  fixCSRF(){
    const oldCsrfToken = this.formTarget.querySelector('[name="authenticity_token"]').value;
    const newCsrfToken = document.querySelector('[name="csrf-token"]').getAttribute('content');
    //console.log(`Old CSRF Token: ${oldCsrfToken}, New CSRF Token: ${newCsrfToken}`);
    this.formTarget.querySelector('[name="authenticity_token"]').value = newCsrfToken;
  }

}